export default __webpack_public_path__ + "static/media/berny.e39779fc.mp3";